module.exports = __webpack_public_path__ + "img/39.1d70170c.jpg";